// Screens of the PropInvest app (1.4.0), cut from the App Store screenshot set.
// Files live in website/public/images/app/<key>.webp + .jpg (600×1304).

export type AppScreenKey =
  | 'home'
  | 'explore'
  | 'property'
  | 'qualify'
  | 'group-calc'
  | 'millionaire'
  | 'insights'
  | 'article'
  | 'reviews'
  | 'learn';

export interface AppScreen {
  key: AppScreenKey;
  label: string;
  caption: string;
}

/** Order matches the App Store listing. */
export const APP_SCREENS: AppScreen[] = [
  { key: 'home', label: 'Home', caption: 'Grow your wealth with hand-picked property investments' },
  { key: 'explore', label: 'Explore', caption: 'Find your next investment across South Africa' },
  { key: 'property', label: 'Development', caption: 'Know every detail: prices, unit plans, amenities' },
  { key: 'qualify', label: 'Affordability check', caption: 'See what you can afford in a minute' },
  { key: 'group-calc', label: 'Group calculator', caption: 'Buy together: the Group Millionaire Strategy' },
  { key: 'millionaire', label: 'Millionaire Strategy', caption: "Use the bank's money: the Millionaire Strategy" },
  { key: 'insights', label: 'Insights', caption: 'Listen or read expert insights on the go' },
  { key: 'article', label: 'Narrated article', caption: 'Every article narrated, even with your phone locked' },
  { key: 'reviews', label: 'Reviews', caption: 'Trusted by investors: real client reviews' },
  { key: 'learn', label: 'Learn', caption: 'Become a confident investor with a free course' },
];

export const appScreenSrc = (key: AppScreenKey, ext: 'webp' | 'jpg') => `/images/app/${key}.${ext}`;
